import { useEffect, useRef, useState } from "react";
import { AccountSwitcher } from "../AccountSwitcher.tsx";

type JampackNavbarProps = {
  status: string;
  phone: string;
  channelLabel: string;
  query: string;
  userEmail: string;
  isAdmin: boolean;
  onQueryChange: (query: string) => void;
  onLogout: () => void;
  onToggleSidebar: () => void;
};

export function JampackNavbar({
  status,
  phone,
  channelLabel,
  query,
  userEmail,
  isAdmin,
  onQueryChange,
  onLogout,
  onToggleSidebar,
}: JampackNavbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const userRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!menuOpen) return;
    function onDocClick(event: MouseEvent) {
      if (userRef.current && !userRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [menuOpen]);

  const connected = status === "connected";
  const initials = (userEmail || "?").trim().charAt(0).toUpperCase();
  const statusLabel = connected
    ? `${channelLabel}: ${phone || "conectado"}`
    : `${channelLabel}: ${status === "syncing" ? "sincronizando" : status}`;

  return (
    <header className="hk-navbar">
      <button
        type="button"
        className="hk-navbar-toggle d-xl-none"
        aria-label="Abrir menu"
        onClick={onToggleSidebar}
      >
        <i className="bi bi-list" />
      </button>

      <div className="hk-search">
        <i className="bi bi-search" />
        <input
          type="text"
          placeholder="Buscar leads..."
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
        />
      </div>

      <div className="hk-navbar-spacer" />

      <div className="hk-navbar-end">
        <span className={`hk-status-pill ${connected ? "is-connected" : status === "syncing" ? "is-syncing" : ""}`} title={statusLabel}>
          <span className="hk-status-dot" />
          {connected ? "Conectado" : status === "syncing" ? "Sincronizando" : "Offline"}
        </span>

        <AccountSwitcher />

        <button type="button" className="hk-icon-btn" aria-label="Notificações" title="Notificações">
          <i className="bi bi-bell" />
          <span className="hk-dot" />
        </button>

        <div className="hk-user" ref={userRef}>
          <button
            type="button"
            className="hk-user-btn"
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="hk-avatar">{initials}</span>
            <span className="hk-user-meta">
              <span className="hk-user-name">{userEmail || "Usuário"}</span>
              <span className="hk-user-role">{isAdmin ? "Administrador" : "Vendedor"}</span>
            </span>
            <i className="bi bi-chevron-down hk-user-caret" />
          </button>

          {menuOpen ? (
            <div className="hk-menu-pop" role="menu">
              <div className="hk-menu-pop-head">
                <div className="nm">{isAdmin ? "Administrador" : "Vendedor"}</div>
                <div className="em">{userEmail}</div>
              </div>
              <button type="button" className="hk-menu-item is-danger" role="menuitem" onClick={onLogout}>
                <i className="bi bi-box-arrow-right" />
                Sair
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}
